<template>
  <div class="loader-container">
    <span class="loader"></span>
  </div>
</template>

<script>
export default {
  name: "LoaderComponent"
}
</script>

<style lang="scss" scoped>
.loader-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  background-color: rgba($color: #ffffff, $alpha: .8);

  .loader {
    position: absolute;
    top: 50%;
    margin-top: -24px;
    left: 50%;
    margin-left: -24px;
    width: 48px;
    height: 48px;
    border: 5px solid #474747;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
